import React, { createContext, useContext, useState, useEffect } from 'react';
import { companyAPI } from '../services/api';

const CompanyContext = createContext();

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};

export const CompanyProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    name: 'Mantra CRM',
    logo: null,
    address: null,
    phone: null,
    email: null,
    website: null
  });
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const response = await companyAPI.getSettings();
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching company settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const updateLogo = (newLogo) => {
    setSettings(prev => ({ ...prev, logo: newLogo }));
  };

  const removeLogo = () => {
    setSettings(prev => ({ ...prev, logo: null }));
  };

  const value = {
    settings,
    loading,
    updateLogo,
    removeLogo,
    refetch: fetchSettings
  };

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
};
